module.exports = "/static/fonts/OpenSans-ExtraBold.ttf";